// #/services/workspaces/updateWorkspace.ts
import { IWorkspace } from '#/types/workspace';

import getWorkspace from './getWorkspace';
import writeWorkspace from './writeWorkspace';

export default async function updateWorkspace(args: {
  ownerAddress: string;
  workspaceUuid: string;
  updatedWorkspace: Partial<IWorkspace>;
}): Promise<IWorkspace> {
  try {
    const { ownerAddress, workspaceUuid, updatedWorkspace } = args;

    const currentWorkspace = await getWorkspace({
      ownerAddress,
      workspaceUuid,
    });

    console.debug('[updateWorkspace] currentWorkspace:', currentWorkspace);

    const mergedWorkspace = {
      uuid: workspaceUuid,
      ...currentWorkspace,
      ...updatedWorkspace,
    };

    console.debug('[updateWorkspace] mergedWorkspace:', mergedWorkspace);

    await writeWorkspace({
      ownerAddress,
      workspaceUuid,
      workspace: mergedWorkspace,
    });

    return mergedWorkspace;
  } catch (error: any) {
    console.error(error);
    throw new Error(`Error updating workspace: ${error.message}`);
  }
}
